<button mat-fab id="comment-fab" (click)="openFeedbackForm()" title="Help" style="z-index: 2">
    <mat-icon style="color: #fff; transform: scale(1.25)">help_outlined</mat-icon>
</button>
<!-- 
<ol>
    <li>
        <mat-form-field>
            <mat-label>What's your name?</mat-label>
            <input matInput [(ngModel)]="name" />
        </mat-form-field>
    </li>
    <li>
        <button mat-raised-button (click)="openDialog()">Pick one</button>
    </li>
    @if (animal()) {
    <li>
        You chose: <em>{{ animal() }}</em>
    </li>
    }
</ol> -->
